module.exports = __webpack_public_path__ + "assets/img/hm2.8cdbdffe.jpg";